import useSWR, { type SWRConfiguration } from "swr";
import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import { config } from "@/config";
import type { CollarLogsGeoJsonResponse } from "@services/device/collar/getGeoJsonLog/type";

async function getCollarLogsGeoJson(
  individualId: string,
): Promise<CollarLogsGeoJsonResponse> {
  const url = apiPaths.individuals.logs.getGeoJson(individualId);
  const response = await apiClient.get<CollarLogsGeoJsonResponse>(url);

  return response.data;
}

export function useGetCollarLogsGeoJson(
  individualId: string,
  options?: SWRConfiguration & { enabled?: boolean },
) {
  const enabled = options?.enabled ?? true;

  const mergedOptions: SWRConfiguration = {
    ...config.swr,
    ...options,
  };

  return useSWR(
    enabled ? ["fetch-individual-collar-logs-geojson", individualId] : null,
    () => getCollarLogsGeoJson(individualId),
    mergedOptions,
  );
}
